const NS = 'NotificationResultsFilterWidget';
const CLS = 'notificationResultsFilterWidget';

export class NotificationResultsFilterWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.notificationsApi = this.$element.data('notificationsApi');
		this.nonotifications = this.$element.data("nonotifications");
		this.notificationDetailApi = this.$element.data('notificationDetailApi');
		
		this.$notificationDetailContainer = this.$element.find(`.${CLS}-notificationDetailContainer`);
		this.$notifications = this.$element.find(`.${CLS}-notifications`);
		this.notificationAnimationDuration = 600;

		this.params = {};
		this.loadNotifications(this.params);

		// Filter the notifications using the select filters
		this.$element.find(`select.${CLS}-filter`).on('change', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');

			if(!(_.isNil(this.params[filterKey]) && $element.val() === '')) {
				// Ensure that the filter-key does not match the current select value
				if(this.params[filterKey] !== $element.val()) {
					if(_.isNil($element.val()) || $element.val() === '') {
						delete this.params[filterKey];
					}
					else {
						this.params[filterKey] = $element.val();
					}

					this.loadNotifications(this.params);
				}
			}
		});

		// Clears the filters and loads the notifications
		this.$element.find(`.${CLS}-filters--clear`).on('click', () => {
			$(`select.${CLS}-filter`).each((index, element) => {
				let filterKey = $(element).data('filter-key');
				delete this.params[filterKey]; // Empty filter key object
				$(element).val('').change();
			});
			this.loadNotifications(this.params);
		});
	}

	loadNotifications(params) {
		let url = this.notificationsApi;

		if(!_.isEmpty(params)) {
			url += `?${$.param(params)}`;
		}

		$.ajax({
			type: 'GET',
			url: url,
			dataType: 'json',
			success: (response) => {
				let notifications = response;
				if(notifications && notifications.length > 0) {
					this.toggleNotifications(false, true, () => {
						// Clear notificationDetailContainers
						this.$notificationDetailContainer.html(null);
					});

					this.$notifications.html(this.getNotificationItemsMarkup(notifications));

					// Latch click event to generated notifications markup
					this.$element.find(`.${CLS}-notification`).on('click', (event) => {
						let $notification = $(event.currentTarget);
						let $notificationDetail = $(`.${CLS}-notificationDetail`);
						let notificationId = $notification.data('notification-id');

						this.$element.find(`.${CLS}-notification`).removeClass(`${CLS}-notification--selected`);

						// If clicking on a notification that is equal to the notificationDetailId
						if($notificationDetail.data('notification-id') === notificationId) {
							this.toggleNotifications(false, true, () => {
								// Clear notificationDetailContainer
								this.$notificationDetailContainer.html(null);
							});
						}
						// Retreive the notification detail from the API
						else {
							this.loadNotificationDetail(notificationId, $notification);
						}
					});
				}
				else {
					this.toggleNotifications(false, true, () => {
						this.$notificationDetailContainer.html(null);
					});
					this.$notifications.html(this.getNotificationDetailEmptyMarkup());
				}
			}
		});
	}

	// Loads the notification detail and marks it as read
	loadNotificationDetail(notificationId, $notification, animate = true) {
		$.ajax({
			type: 'GET',
			url: `${this.notificationDetailApi}/${notificationId}`,
			dataType: 'json',
			success: (response) => {
				this.$notificationDetailContainer.html(this.getNotificationDetailMarkup(response, notificationId));
				$notification.addClass(`${CLS}-notification--selected`);

				// Animates the notificationDetail in by shrinking the width of the notifications list
				this.toggleNotifications(true, animate, () => {
					// Mark as read
					$notification.removeClass(`${CLS}-notification--unread`);
				});

				// Attach the close notification event
				this.$element.find(`.${CLS}-notificationDetail-back`).on('click', () => {
					this.toggleNotifications(false, animate, () => {
						// Clear notifiationDetailContainer
						this.$notificationDetailContainer.html(null);
					});
				});
			}
		});
	}

	toggleNotifications(reveal, animate, callback) {
		if(animate) {
			this.$notifications.addClass(`${CLS}-notifications--animate`);
		}
		else {
			this.$notifications.removeClass(`${CLS}-notifications--animate`);
		}

		if(reveal) {
			this.$notifications.removeClass(`${CLS}-notifications--conceal`);
			this.$notifications.addClass(`${CLS}-notifications--reveal`);
		}
		else {
			this.$notifications.addClass(`${CLS}-notifications--conceal`);
			this.$notifications.removeClass(`${CLS}-notifications--reveal`);
		}

		if(animate) {
			setTimeout(() => {
				callback();
			}, this.notificationAnimationDuration);
		}
		else {
			callback();
		}
	}

	getNotificationItemsMarkup(notifications) {
		let notificationsMarkup = '';
		notifications.forEach((notification) => {
			notificationsMarkup += `
			<div data-notification-id="${notification.Id}" class="${CLS}-notification ${ notification.Selected ? `${CLS}-notification--selected` : '' } ${ !notification.IsRead ? `${CLS}-notification--unread` : '' }">
				${(() => {
					if(notification.DatePublished) {
						return `<span class="${CLS}-notification-date">${notification.DatePublished}</span>`;
					}
					return '';
				})()}
				${(() => {
					if(notification.Title) {
						return `<h3 class="${CLS}-notification-title">${notification.Title}</h3>`;
					}
					return '';
				})()}
				${(() => {
					if(notification.Summary) {
						return `<div class="${CLS}-notification-description">${notification.Summary}</div>`;
					}
					return '';
				})()}
				<span class="${CLS}-notification-link"></span>
			</div>`;
		});
		return notificationsMarkup;
	}

	getNotificationDetailMarkup(notification) {
		return `<div id="${CLS}-notificationDetail" class="${CLS}-notificationDetail ${CLS}-notificationDetail--conceal" data-notification-id="${notification.Id}">
			<div class="${CLS}-notificationDetail-header">
				<a href="javascript:void(0)" class="${CLS}-notificationDetail-back"><i class="${CLS}-icon icon icon--chevron-left"></i>Back</a>
				${(() => {
					if(notification.DatePublished) {
						return `<div class="${CLS}-notificationDetail-date">${notification.DatePublished}</div>`;
					}
					return '';
				})()}
			</div>
			<div class="${CLS}-notificationDetail-inner">
				${(() => {
					if(notification.Title) {
						return `<h2 class="${CLS}-notificationDetail-title">${notification.Title}</h2>`;
					}
					return '';
				})()}
				${(() => {
					if(notification.Content) {
						return `<div class="${CLS}-notificationDetail-description">${notification.Content}</div>`;
					}
					return '';
				})()}
			</div>
		</div>`;
	}

	getNotificationDetailEmptyMarkup() {
		return this.nonotifications;
	}
}
